import '../sass/styles.scss';

import './function/keyboard-navigation';
import './component/header';
import './component/webcast';
import './component/accordion';
import './component/menu';
import './component/headerSearch';
import './component/lang-selector';
import './component/autocomplete';
import './component/veidekkeMap';
import './component/stock';
import './component/feature-article-inview';
//import './component/parallax';
import './component/scrollytell';
import './component/jobsQueries';
import './component/view-more-list';
// import './component/in-page-filter';
import './component/filter';
import './component/tag-filter';
import './component/project-cards';
import './component/company-cards';
import './component/contact-cards';
import './component/pricecalculator';
import './component/financial-calendar';
